import React from "react";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import foto from "../../images/News/Promo_palestra.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import SpaceL from "../../commons/SpaceL";

function PromoPalestraNews () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{"20.03.2026"}</p>
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <a style={{alignSelf: "end"}} href={foto} download>
                    <i style={{fontSize: "2em", color: "grey", marginRight: "0.5em"}} className="bi bi-download"></i>
                </a>
                <img src={foto} style={{width: "100%"}}></img>
            </div>
            <SpaceL/>
        </div>
    )
}
export default PromoPalestraNews